"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iteration = exports.Reducer = exports.ValueReducer = void 0;
var Iteration = /** @class */ (function () {
    /** @hidden */
    function Iteration(parent, currValue, index, list) {
        this.parent = parent;
        this.curr = currValue;
        this.index = index;
        this.list = list;
        this.prev = this.prev.bind(this);
        this.put = this.put.bind(this);
    }
    /**
     *
     * @returns The currently accumulated value (i.e. the last value passed to 'proceed', or the default value passed to 'init' if none was passed). Every reducer in the list references the same 'prev' value, so that you can do [0].prev() and easily get the accumulated value without having to access the last item in the list.
     */
    Iteration.prototype.prev = function () {
        return this.parent.result();
    };
    /**
     * @param newValue The new accumulated value, which will then be accessible via 'prev()'.
     * @returns the Iteration TODO: is this necessary still?
     */
    Iteration.prototype.put = function (newValue) {
        this.parent.updatePrev(newValue);
        return this.parent;
    };
    return Iteration;
}());
exports.Iteration = Iteration;
var Reducer = /** @class */ (function () {
    /** @hidden */
    function Reducer(items, initialValue) {
        var _this = this;
        this.prev = initialValue;
        this.forEach = items.map(function (item, index, list) { return new Iteration(_this, item, index, list); });
        this.acc = this;
        this.updatePrev = this.updatePrev.bind(this);
        this.result = this.result.bind(this);
    }
    /** @hidden */
    Reducer.prototype.updatePrev = function (newPrev) {
        this.prev = newPrev;
    };
    /**
     * @returns The result of the reduce (i.e. the last value passed to a 'put' call, or the default value.)
     */
    Reducer.prototype.result = function () {
        return this.prev;
    };
    return Reducer;
}());
exports.Reducer = Reducer;
var ValueReducer = /** @class */ (function () {
    /** @hidden */
    function ValueReducer(items) {
        this.items = items !== null && items !== void 0 ? items : [];
        this.startingWith = this.startingWith.bind(this);
    }
    ValueReducer.prototype.startingWith = function (initialValue) {
        return [new Reducer(this.items, initialValue)];
    };
    return ValueReducer;
}());
exports.ValueReducer = ValueReducer;
//# sourceMappingURL=ValueReducer.js.map